import React, { Component } from "react";

class TableFooter extends Component {
  renderCell = (column, index) => {
    if (column.content) return column.content();
  };

  createKey = (item, column) => {
    return item._id + (column.path || column.key);
  };

  render() {
    const { columns, columns2, columns3 } = this.props;
    return (
      <tfoot>
        <tr>
          {columns
            ? columns.map((column, index) => (
                <React.Fragment key={index}>
                  {this.renderCell(column, index)}
                </React.Fragment>
              ))
            : null}
        </tr>
        {columns2 && (
          <tr>
            {columns2
              ? columns2.map((column, index) => (
                  <React.Fragment key={index}>
                    {this.renderCell(column, index)}
                  </React.Fragment>
                ))
              : null}
          </tr>
        )}
        {columns3 && (
          <tr>
            {columns3
              ? columns3.map((column, index) => (
                  <React.Fragment key={index}>
                    {this.renderCell(column, index)}
                  </React.Fragment>
                ))
              : null}
          </tr>
        )}
      </tfoot>
    );
  }
}

export default TableFooter;



// WEBPACK FOOTER //
// ./src/components/Common/tableFooter.jsx